import { render, staticRenderFns } from "./edge.vue?vue&type=template&id=038fd600&scoped=true"
import script from "./edge.vue?vue&type=script&lang=js"
export * from "./edge.vue?vue&type=script&lang=js"
import style0 from "./edge.vue?vue&type=style&index=0&id=038fd600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038fd600",
  null
  
)

export default component.exports